module.exports = __webpack_public_path__ + "static/_0008_KIKESA-ab1317c2093405250385270d6ce224f2.jpg";